import React from 'react'
import { match } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import MaxDance from './max-dance'
import BarberShop from './barbershop'
import OnlineSchool from './onlineSchool'
import EnergyFit from './energyFit'

import Igrolandia from './igrolandia'


interface IParams {
  subview: string
}

interface IStoriesCompanies {
  match: match<IParams>
}

interface IstoryPage {
  title: string
  component: React.ReactNode
}

interface IstoryPages {
  [item: string]: IstoryPage
}

const storyPages: IstoryPages = {
  max_dance: {
    title: 'Школа танцев',
    component: <MaxDance />
  },
  barbershop: {
    title: 'Барбершоп',
    component: <BarberShop />
  },
  energy_fit: {
    title: 'Фитнес-клуб',
    component: <EnergyFit />
  },
  igrolandia: {
    title: 'Игроландия',
    component: <Igrolandia />
  },
  online_school: {
    title: 'Онлайн-школа',
    component: <OnlineSchool />
  }
}


export const StoriesCompanies: React.FC<IStoriesCompanies> = (props) => {
  const { match } = props
  const { subview } = match.params
  return (
    <DocumentTitle title={`«onlinePBX» - ${storyPages[subview].title}`}>
      <div className='onlinepbx__head'>
        {storyPages[subview].component}
      </div>
    </DocumentTitle>
  )
}

export default StoriesCompanies
